import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { Input } from 'web-ui-components/lib/atoms/forms';
import withValidation from '../../../containers/withValidation';
import { MaximumRepeatingTimes } from '../../../config';
import { cleanIllegalRepeatingPaymentCharacters } from '../../../helpers/fieldHelpers';

const PaymentRepeatingTimes = ({
	stopOnNumberLabel,
	stopPaymentOnNumber,
	handleStopPaymentOnNumberChange,
	errorMessage,
}) => {
	const handleChange = (event) => {
		const validNumberOfTimesPayment = cleanIllegalRepeatingPaymentCharacters(event.target.value);
		handleStopPaymentOnNumberChange(validNumberOfTimesPayment);
	};
	return (
		<Field>
			<FieldHeader
				name="field-payment-times"
				titleText={stopOnNumberLabel}
				hasError={!!errorMessage}
				validationMessage={errorMessage}
			/>
			<FieldBody>
				<Input
					type="text"
					className="c-a-input c-a-input--number"
					id="field-stop-payment-on-number"
					required=""
					aria-required="true"
					aria-invalid="true"
					value={stopPaymentOnNumber}
					onChange={handleChange}
				/>
			</FieldBody>
		</Field>
	);
};

PaymentRepeatingTimes.propTypes = {
	stopOnNumberLabel: PropTypes.string,
	stopPaymentOnNumber: PropTypes.string,
	handleStopPaymentOnNumberChange: PropTypes.func,
	errorMessage: PropTypes.string,
};

export { PaymentRepeatingTimes };
export default withValidation({
	validations: ['required', 'maximum'],
	key: 'stopPaymentOnNumber',
	message: {
		required: 'Please enter the number of times you want to move this money before it stops.',
		maximum: `Sorry, this exceeds the amount of repeating transactions you can set up. Please enter ${MaximumRepeatingTimes} or less then try again.`,
	},
})(PaymentRepeatingTimes);
